import { IImageProps } from 'telia-front-react';
import { BranchWithHours, TranslationMap } from '../../stores/BranchStore';
import { Language } from '../../stores/LanguageStore';

export const localizeClockHourAndMinuteSeparator = (time: string, language: string): string => {
  return language === 'et' ? time.replace(':', '.') : time;
};

export const getTranslationFallbackEt = (text: TranslationMap, currentLang: string): string => {
  return text ? text[currentLang as Language] || text.et : null;
};

export const hasTransportTexts = (branch: BranchWithHours, lang: string): boolean => {
  return !!getTranslationFallbackEt(branch?.arrivalWithPublicTransport, lang) || !!getTranslationFallbackEt(branch?.arrivalWithCar, lang);
};

export const branchBackgroundImage: IImageProps = {
  role: 'presentation',
  sources: [
    {
      srcset:
        'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_2560/tweb/kontaktid/esindused/hero.png 2560w, https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_5120/tweb/kontaktid/esindused/hero.png 5120w',
      minWidth: '1920px'
    },
    {
      srcset:
        'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_1920/tweb/kontaktid/esindused/hero.png 1920w, https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_3840/tweb/kontaktid/esindused/hero.png 3840w',
      minWidth: '1441px'
    },
    {
      srcset:
        'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_1440/tweb/kontaktid/esindused/hero.png 1440w, https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_2880/tweb/kontaktid/esindused/hero.png 2880w',
      minWidth: '1201px'
    },
    {
      srcset:
        'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_1240/tweb/kontaktid/esindused/hero.png 1240w, https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_2480/tweb/kontaktid/esindused/hero.png 2480w',
      minWidth: '800px'
    }
  ],
  srcset:
    'https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_320/tweb/kontaktid/esindused/mobile_hero_ba%CC%88nner_export_4x.png 320w,https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_640/tweb/kontaktid/esindused/mobile_hero_ba%CC%88nner_export_4x.png 640w,https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_960/tweb/kontaktid/esindused/mobile_hero_ba%CC%88nner_export_4x.png 960w,https://res.cloudinary.com/telia/image/upload/f_auto,fl_lossy,q_auto:best,w_1280/tweb/kontaktid/esindused/mobile_hero_ba%CC%88nner_export_4x.png 1280w'
};

export const branchCloudinaryShopPicsUrl = 'https://res.cloudinary.com/telia/image/upload/q_auto:best,f_auto,fl_lossy/ci-frontend/esindused/';
